import React, { useState, useEffect, useRef } from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import PostRequest from 'components/common/PostRequest.jsx';
import LayoutNavSectionCombinationListList from 'components/layout_and_quote_builder/LayoutNavSectionCombinationListList.jsx';
import { ProgressProvider } from 'components/layout_and_quote_builder/utils/ProgressContext.jsx';
import ProgressBarOverlay from 'components/layout_and_quote_builder/ProgressBarOverlay.jsx';

const LayoutNavSectionCombinationList = ({ navSection, index, count, setSelectedList, materialLayoutDimensions, previousSelectedList}) => {
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)
  const [manuallyEnabled, setManuallyEnabled] = useState(false)
  const showAllRef = useRef(false)
  const show_more_count = 300;

  const [navSectionCombinations, setNavSectionCombinations] = useState( [ ] )

  // Check if we should fetch combinations based on previous section's selectedList
  const shouldFetch = previousSelectedList === null || (previousSelectedList && previousSelectedList.length > 0);

  const lastFetchTime = useRef(0);
  const fetchCombinations = () => {
    // Don't fetch if previous section has no selections and user hasn't manually enabled
    if (!shouldFetch && !manuallyEnabled) {
      setLoading(false);
      setNotFound(false);
      return;
    }

    const now = Date.now();
    if (now - lastFetchTime.current < 100) {  return; }
    lastFetchTime.current = now;

    setLoading( () => true )

    PostRequest({
      url: `/layouts-nav-section-combinations/${window.drawingId}/${materialLayoutDimensions.layout_dimension_id}/${index}/${count}`,
      data: {
        formula_options: window.dielineOptions,
        material_layout_dimensions: materialLayoutDimensions,
        user_quote_id: window.user_quote_id
      },
      callback: (data) => {
        setNavSectionCombinations( () => data.solutions )
        setLoading( () => false );
        setNotFound( () =>  data.solutions.length == 0 )

        if(data.auto_select) {
          setSelectedList( data.solutions[0] )
        }
      }

    })
  }

   const sortingInProgress = useRef(false)
   const myRef = useRef();
   const sortDivs = () => {
    if (sortingInProgress.current) return;

    sortingInProgress.current = true;

    var $items = $(myRef.current).children("div");

    let isSorted = true;
    for (let i = 0; i < $items.length - 1; i++) {
        let num_i = parseInt($($items[ i ]).attr("data-score"));
        let num_i_plus_1 = parseInt ($($items[ i+1 ]).attr("data-score"));
        if (num_i > num_i_plus_1 ) {
            isSorted = false;
            break;
        }
    }

    if (!isSorted) {
      $items.sort((a, b) => parseInt($(a).attr("data-score"))  -  parseInt( $(b).attr("data-score") ) );
      $(myRef.current).append($items);
    }

    // Calculate and add star ratings directly to DOM (no React state)
    if ($items.length > 0) {
      const scores = $items.toArray().map(item => parseInt($(item).attr("data-score"))).filter(score => !isNaN(score));
      if (scores.length > 0) {
        const minScore = Math.min(...scores.filter(s => s > 0));
        const maxScore = Math.max(...scores.filter(s => s > 0));
        const range = maxScore - minScore;

        $items.each((index, item) => {
          const score = parseInt($(item).attr("data-score"));
          if (!isNaN(score) && range > 0) {
            const normalizedScore = (score - minScore) / range;
            const starRating = 5 - (normalizedScore * 4); // Scale from 5 to 1 instead of 5 to 0
            const clampedRating = Math.max(1, Math.min(5, starRating)); // Minimum 1 star

            // Round to 1 decimal place to avoid mismatch between displayed text and star rendering
            const roundedRating = Math.round(clampedRating * 10) / 10;

            // Find or create the stars container
            let $starsContainer = $(item).find('.stars-rating-container');
            if ($starsContainer.length === 0) {
              $starsContainer = $('<span class="stars-rating-container"></span>');
              $(item).find('[data-score]').first().parent().prepend($starsContainer);
            }

            // Use manual stars for all ratings for consistent sizing
            const fullStars = Math.floor(roundedRating);
            const remainder = roundedRating - fullStars;
            const hasHalfStar = remainder >= 0.25 && remainder < 0.75;
            const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

            let starsHtml = '<span style="color: #ffc107; font-size: 14px; margin-left: 8px;">';

            // Full stars
            for (let i = 0; i < fullStars; i++) {
              starsHtml += '★';
            }

            // Half star using CSS overlay
            if (hasHalfStar) {
              starsHtml += '<span style="position: relative; display: inline-block;">' +
                '<span style="color: #ddd;">★</span>' +
                '<span style="position: absolute; left: 0; width: 50%; overflow: hidden; color: #ffc107;">★</span>' +
                '</span>';
            }

            // Empty stars
            for (let i = 0; i < emptyStars; i++) {
              starsHtml += '☆';
            }

            starsHtml += ' <span style="margin-left: 4px; color: #666; font-size: 13px;">' + roundedRating.toFixed(1) + '</span></span>';

            $starsContainer.html(starsHtml);
          }
        });
      }
    }

    // Apply visibility after sorting
    if (!myRef.current) {
      sortingInProgress.current = false;
      setTimeout(sortDivs, 200)
      return;
    }

    var $items2 = $(myRef.current).children("div");

    if (!showAllRef.current && $items2.length > show_more_count) {
      $items2.each((index, item) => {
        if (index < show_more_count) {
          $(item).removeClass(styles.hidden_combination);
        } else {
          $(item).addClass(styles.hidden_combination);
        }
      });
    } else {
      // Show all items
      $items2.removeClass(styles.hidden_combination);
    }

    sortingInProgress.current = false;
    setTimeout(sortDivs, 200)
  };

  const showNavSectionCombinationGroup = ( list ) => {
    return <LayoutNavSectionCombinationListList list={list} count={count} setSelectedList={setSelectedList} />
  }

  const randomString = Math.random().toString(36).substring(2, 10);

  const CombinationsContent = () => {
    const hasMoreThanFour = navSectionCombinations.length > 4;

    // Show button if we have more than 4 items and showAll is false
    // This component only renders when loading is false, so we don't need to check loading state
    const shouldShowButton = hasMoreThanFour

    return (
      <div style={{ position: 'relative' }}>
        <ProgressBarOverlay />
        <div ref={myRef} className={styles.combinations_grid}>
          {navSectionCombinations.map((list, index) => (
            <React.Fragment key={index}>
              {showNavSectionCombinationGroup(list)}
            </React.Fragment>
          ))}
        </div>

        {shouldShowButton && (
          <div className={`${styles.show_more_container} ${randomString}`}>
            <button
              onClick={() => {
                showAllRef.current = true;
                $(`.${randomString}`).addClass('hidden');
              }}
              className={styles.show_more_button}
            >
              {t('quote_builder.show_more')}
            </button>
          </div>
        )}
      </div>
    );
  };

  // useEffect starts
  useEffect(fetchCombinations, [ count, materialLayoutDimensions, previousSelectedList, manuallyEnabled ])
  useEffect(sortDivs, [ ])

  // useEffect ends

  // Show button to enable fetching if shouldFetch is false and not manually enabled
  if (!shouldFetch && !manuallyEnabled) {
    return <div className={styles.waitingMessage}>
      <p> { t('quote_builder.this_section_not_yet_active') } </p>

      <button
        onClick={() => setManuallyEnabled(true)}
        className="btn simple-btn"
      >
        { t('quote_builder.start_working_on_this_section') }
      </button>
    </div>
  }

  if(notFound) {
    return t('quote_builder.solution_cannot_be_found')
  }

  return (
    <ProgressProvider>
      <div>
        {loading && <div> <center> <img src="https://d2atdwxjx7uc4i.cloudfront.net/images/bx_loader.gif" width="30px"/> </center></div> }

        {!loading && <CombinationsContent />}

      </div>
    </ProgressProvider>
  )
}

export default LayoutNavSectionCombinationList;
